import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

// Commercial League colours (https://basketball.commercial-league.gr): teal on charcoal,
// with the teal-to-blue gradient of the website for highlights (see App.vue)
export default new Vuetify({
    theme: {
        themes: {
            light: {
                // brand teal: focused fields, checkboxes, pickers and anything else using "primary"
                primary: '#009688',
                secondary: '#232323',
                accent: '#037ade'
            }
        }
    }
})
